import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import { boardSlice } from "../features/board/boardSlice";
import { articlesSlice } from "../features/articles/articlesSlice";
import { accountingApiSlice } from "../features/accounting/accountingApiSlice";
import { identitySlice } from "../features/identity/identityApi";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [boardSlice.reducerPath]: boardSlice.reducer,
    [articlesSlice.reducerPath]: articlesSlice.reducer,
    [identitySlice.reducerPath]: identitySlice.reducer,
    [accountingApiSlice.reducerPath]: accountingApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(
      apiSlice.middleware,
      boardSlice.middleware,
      articlesSlice.middleware,
      identitySlice.middleware,
      accountingApiSlice.middleware
    ),
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
